define('chartApi/filters',['knockout', 'lodash', 'moment', 'atn/atn', 'dataSource/timeData'],
    function(ko, _, moment, atn, timeData) {
        'use strict';

        var filterGenerators = {
            date: createDateFilter,
            duration: createDurationFilter,
            interval: createIntervalFilter
        };

        return {
            createFilter: createFilter
        };

        function createFilter(filterConfig, userFilterConfig, additionalConfig) {
            return filterGenerators[filterConfig.id](filterConfig, userFilterConfig, additionalConfig);
        }

        function createDateFilter(filterConfig, userFilterConfig) {
            var selectedChoice = ko.observable(),
                customPointInTime = ko.observable(),
                isCustomMenuShown = ko.observable(false),
                env = createEnv(),
                selectedChoiceText = ko.computed(
                    getComputeSelectedChoiceText(selectedChoice, filterConfig)
                );

            if (userFilterConfig) {
                selectedChoice(userFilterConfig.value);
                customPointInTime(moment(userFilterConfig.customPointInTime || timeData.timeBoundary())._d);
            } else {
                selectedChoice(filterConfig.default);
                customPointInTime(moment(timeData.timeBoundary())._d);
            }

            var customObj = {
                customFilter: {
                    toggleIsShown: function() {
                        //case when custom menu is gonna close without setting custom date.
                        // Set defaults before closing custom date window in this case
                        if (isCustomMenuShown()) {
                            selectedChoice(filterConfig.default);
                            if (userFilterConfig) {
                                customPointInTime(moment(userFilterConfig.customPointInTime || timeData.timeBoundary())._d);
                            } else {
                                customPointInTime(moment(timeData.timeBoundary())._d);
                            }
                            env.trigger();
                        }
                        isCustomMenuShown(!isCustomMenuShown());
                    },
                    isShown: isCustomMenuShown,
                    date: customPointInTime,
                    messages: atn.config.messages.filters.custom,
                    validateEndDate: ko.computed(function() {
                        var maxDate = moment(timeData.timeBoundary()).seconds(0);
                        var endDate = moment(customPointInTime()).seconds(0);
                        return endDate.isAfter(maxDate);
                    }),
                    dataAvaibilityDate: moment(timeData.timeBoundary()).format(atn.config.dayGeneratedOnFormat),
                    kendoDateFormat: atn.config.kendoDateFormat,
                    triggerUpdate: function() {
                        //send custom dates
                        env.trigger();
                        isCustomMenuShown(!isCustomMenuShown());
                    }
                }
            };

            return _.assign({
                    get value() {
                        return {
                            id: selectedChoice.peek(),
                            customPointInTime: customPointInTime.peek()
                        };
                    },
                    changeDate: function(dateObj) {
                        selectedChoice(dateObj.id);
                        if (dateObj.id === filterConfig.custom) {
                            isCustomMenuShown(true);
                        } else {
                            customPointInTime(new Date(timeData.timeBoundary()));
                            env.trigger();
                        }
                    },
                    onChange: env.onChange,
                    dateFormatter: function(date) {
                        return moment(date).format(atn.config.dayGeneratedOnFormat);
                    },
                    get options() {
                        return filterConfig.choices;
                    },
                    get selectedText() {
                        return selectedChoiceText();
                    }
                },
                customObj,
                filterConfig, {
                    selectedChoice: selectedChoice,
                    selectedChoiceText: selectedChoiceText
                }
            );
        }

        function createDurationFilter(filterConfig, userFilterConfig) {
            var env = createEnv(),
                selectedChoice = ko.observable(),
                customStartDate = ko.observable(),
                customEndDate = ko.observable(),
                selectedChoiceText = ko.computed(
                    getComputeSelectedChoiceText(selectedChoice, filterConfig)
                ),
                isCustomMenuShown = ko.observable(false);

            if (userFilterConfig) {
                selectedChoice(userFilterConfig.value);
                customStartDate(moment(userFilterConfig.customStartDate || timeData.timeBoundary())._d);
                customEndDate(moment(userFilterConfig.customEndDate || timeData.timeBoundary())._d);
            } else {
                selectedChoice(filterConfig.default);
                customStartDate(moment(timeData.timeBoundary())._d);
                customEndDate(moment(timeData.timeBoundary())._d);
            }

            var customObj = {
                customFilter: {
                    toggleIsShown: function() {
                        if (isCustomMenuShown()) {
                            selectedChoice(filterConfig.default);
                            customStartDate(moment(timeData.timeBoundary())._d);
                            customEndDate(moment(timeData.timeBoundary())._d);
                            env.trigger();
                        }
                        isCustomMenuShown(!isCustomMenuShown());
                    },
                    startDate: customStartDate,
                    endDate: customEndDate,
                    isShown: isCustomMenuShown,
                    validateDateRange: ko.computed(function() {
                        var startDate = moment(customStartDate()).seconds(0);
                        var endDate = moment(customEndDate()).seconds(0);
                        return endDate.isBefore(startDate);
                    }),
                    validateEndDate: ko.computed(function() {
                        var maxDate = moment(timeData.timeBoundary()).seconds(0);
                        var endDate = moment(customEndDate()).seconds(0);
                        return endDate.isAfter(maxDate);
                    }),
                    validateStartDate: ko.computed(function() {
                        var maxDate = moment(timeData.timeBoundary()).seconds(0);
                        var startDate = moment(customStartDate()).seconds(0);
                        return startDate.isAfter(maxDate);
                    }),
                    dataAvaibilityDate: moment(timeData.timeBoundary()).format(atn.config.dayGeneratedOnFormat),
                    kendoDateFormat: atn.config.kendoDateFormat,
                    messages: atn.config.messages.filters.custom,
                    triggerUpdate: function() {
                        env.trigger();
                        isCustomMenuShown(!isCustomMenuShown());
                    }
                }
            };

            return _.assign({
                    get value() {
                        return {
                            id: selectedChoice(),
                            customStartDate: customStartDate(),
                            customEndDate: customEndDate()
                        };
                    },
                    changeDuration: function(durationObj) {
                        selectedChoice(durationObj.id);
                        if (durationObj.id === filterConfig.custom) {
                            isCustomMenuShown(true);
                        } else {
                            env.trigger();
                        }
                    },
                    dateFormatter: function(date) {
                        return moment(date).format(atn.config.dayGeneratedOnFormat);
                    },
                    onChange: env.onChange,
                    get options() {
                        return filterConfig.choices;
                    },
                    get selectedText() {
                        return selectedChoiceText();
                    }
                },
                customObj,
                filterConfig, {
                    selectedChoice: selectedChoice,
                    selectedChoiceText: selectedChoiceText
                }
            );
        }

        function createIntervalFilter(filterConfig, userFilterConfig, additionalConfig) {
            /**
             * No user preferences yet
             */
            var env = createEnv(),
                selectedInterval = ko.observable(),
                intervalOptions = ko.observableArray(),
                showIntervalFilter = ko.observable(false),
                selectedIntervalText = ko.computed(computeSelectedIntervalText);

            intervalOptions.subscribe(function(intervals) {
                showIntervalFilter(isMultipleIntervals(intervals));
            });

            return _.assign({
                    get value() {
                        return selectedInterval();
                    },
                    changeInterval: function(intervalObj) {
                        selectedInterval(intervalObj.id);
                        env.trigger();
                    },
                    onChange: env.onChange,
                    get options() {
                        return intervalOptions();
                    },
                    get selectedText() {
                        return selectedIntervalText();
                    }
                },
                filterConfig, {
                    selectedInterval: selectedInterval,
                    intervalOptions: intervalOptions,
                    showIntervalFilter: showIntervalFilter,
                    selectedIntervalText: selectedIntervalText,
                    setIntervalOptions: setIntervalOptions,
                    postFlowActions: postFlowActions,
                    initializeRanges: initializeRanges
                }
            );

            function isMultipleIntervals(intervals) {
                return _.isArray(intervals) && intervals.length > 1;
            }

            function computeSelectedIntervalText() {
                var intervals = intervalOptions(),
                    selected = selectedInterval();
                var text = '';
                if (isMultipleIntervals(intervals)) {
                    // since the same object is set earlier
                    var selectedIntervalObj = _.find(intervals, {
                        id: selected
                    });
                    text = selectedIntervalObj && selectedIntervalObj.text;
                }

                return text;
            }

            function setIntervalOptions(intervalRange) {
                intervalOptions(_.map(intervalRange, function(id) {
                    return {
                        id: id,
                        text: id.min + ' - ' + id.max
                    };
                }));
            }

            function postFlowActions(context) {
                setIntervalOptions(context.returnFiltersArray);
                selectedInterval(context.selectedInterval);
            }

            function initializeRanges() {
                setIntervalOptions(additionalConfig.INTERVALS);
            }
        }

        function getComputeSelectedChoiceText(selectedChoice, filterConfig) {
            return function() {
                var text = null,
                    selectedChoiceValue = _.find(
                        filterConfig.choices, {
                            id: selectedChoice()
                        }
                    );
                if (selectedChoiceValue) {
                    text = selectedChoiceValue.text;
                }
                return text;
            };
        }

        function getCustomPointInTime() {
            return moment(timeData.timeBoundary()).format(atn.config.dayGeneratedOnFormat);
        }

    });

function createEnv() {
    var listeners = [];

    return {
        onChange: onChange,
        trigger: trigger
    };

    function onChange(fn) {
        listeners.push(fn);
    }

    function trigger() {
        _.forEach(listeners, _.defer);
    }
}
;
